import styled from "styled-components";

export const PortalRootWrapper = styled.div`
  max-width: 100%;
  overflow-x: clip;
`;

export const BodyAndSidebarWrapper = styled.div<{ $hasSubSidebar?: boolean; $isChatView?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 100vh;
  padding-left: ${(props) => {
    if (props.$hasSubSidebar) return "520px"; // 240px sidebar + 280px subbarra
    return "240px"; // 240px sidebar
  }};
  transition: padding-left 0.3s ease;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    flex-direction: column;
    padding-left: 0;
    align-items: stretch;
    /* Chat manages its own internal scroll and needs a single-viewport-tall
       container; other pages (e.g. DD report) scroll past one viewport, and a
       fixed height here caps the mobile header's sticky containing block to
       that first screen, detaching it once the page scrolls further. */
    ${(props) => (props.$isChatView ? "height: 100vh;" : "")}
  }
`;

export const PortalRootBody = styled.div<{ $isChatView?: boolean }>`
  flex: 1;
  min-width: 0;
  margin-top: 0;
  margin-bottom: ${(props) => (props.$isChatView ? "0" : "0")};
  padding-left: ${(props) => (props.$isChatView ? "16px" : props.theme.spacing.large)};
  padding-right: ${(props) => (props.$isChatView ? "16px" : "0")};
  margin-right: ${(props) => (props.$isChatView ? "0" : props.theme.spacing.large)};
  background-color: ${(props) => (props.$isChatView ? "#ffffff" : "transparent")};

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    flex-direction: column;
    padding-left: ${(props) => (props.$isChatView ? "16px" : props.theme.spacing.medium)};
    padding-right: ${(props) => (props.$isChatView ? "16px" : props.theme.spacing.medium)};
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

export const FooterWrapper = styled.div`
  max-width: 100vw;
`;

export const OutletWrapper = styled.div`
  flex: 1;
`;
